export const ANATOMY_POINTS = Object.freeze({
  brain: [336, 77],
  mouth: [337, 192],
  lungs: [276, 432],
  heart: [350, 430],
  vessels: [408, 490],
  liver: [278, 552],
  metabolic: [366, 580],
  stomach: [363, 610],
  kidneys: [245, 673],
  abdomen: [292, 750]
})
